<div class="ws-step">
  <div class="ws-step-header">
    <h3>Visit Outcomes</h3>
    <p class="text-muted">Does your sales team do field visits to meet leads or clients in person?</p>
  </div>

  <div class="ws-step-body">
    @switch (mode) {
      @case ('choose') {
        <div class="d-flex flex-wrap gap-3">
          <div class="ws-option-card" (click)="selectDoVisits()">
            <i class="bi bi-geo-alt-fill" style="color: #43a047;"></i>
            <div class="ws-option-title">Yes, we do field visits</div>
            <div class="ws-option-desc">Our reps visit clients on-site — configure what happens after each visit</div>
          </div>
          <div class="ws-option-card" (click)="skipVisits()">
            <i class="bi bi-telephone-fill" style="color: #5c6bc0;"></i>
            <div class="ws-option-title">No, we work remotely</div>
            <div class="ws-option-desc">We handle everything over calls, emails, and online meetings</div>
          </div>
        </div>
      }

      @case ('outcomes') {
        <p class="text-muted mb-3">After a field visit, your salesperson picks a visit outcome. Add, remove, or edit — here are suggestions based on your business.</p>

        <!-- Positive outcomes -->
        @if (positiveOutcomes.length) {
          <h6 class="mb-2"><span class="ws-chip ws-chip-positive">Positive</span></h6>
          <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'positive')">
            @for (outcome of positiveOutcomes; track outcome.value) {
              <div class="ws-item-card ws-card-positive" [ngClass]="{'selected': outcome.selected}" cdkDrag>
                <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
                <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-positive" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
                <div class="ws-item-content">
                  <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
                  <div class="ws-option-toggle">
                    <span class="ws-toggle-switch" [ngClass]="{'active': outcome.startsNewDeal}" (click)="outcome.startsNewDeal = !outcome.startsNewDeal"></span>
                    <span>Auto-create a deal when rep selects this outcome</span>
                  </div>
                </div>
                <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
              </div>
            }
          </div>
        }

        <!-- Neutral outcomes -->
        @if (neutralOutcomes.length) {
          <h6 class="mb-2 mt-3"><span class="ws-chip ws-chip-neutral">Neutral</span></h6>
          <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'neutral')">
            @for (outcome of neutralOutcomes; track outcome.value) {
              <div class="ws-item-card ws-card-neutral" [ngClass]="{'selected': outcome.selected}" cdkDrag>
                <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
                <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-neutral" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
                <div class="ws-item-content">
                  <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
                </div>
                <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
              </div>
            }
          </div>
        }

        <!-- Negative outcomes -->
        @if (negativeOutcomes.length) {
          <h6 class="mb-2 mt-3"><span class="ws-chip ws-chip-negative">Negative</span></h6>
          <div cdkDropList (cdkDropListDropped)="reorderOutcomes($event, 'negative')">
            @for (outcome of negativeOutcomes; track outcome.value) {
              <div class="ws-item-card ws-card-negative" [ngClass]="{'selected': outcome.selected}" cdkDrag>
                <i class="bi bi-grip-vertical ws-drag-handle" cdkDragHandle></i>
                <input type="checkbox" class="form-check-input ws-item-toggle ws-toggle-negative" [checked]="outcome.selected" (change)="toggleOutcome(outcome)" />
                <div class="ws-item-content">
                  <input class="form-control form-control-sm border-0 p-0 ws-item-name" [(ngModel)]="outcome.name" />
                </div>
                <button class="btn btn-sm btn-link text-danger" (click)="removeOutcome(outcome)"><i class="bi bi-x-lg"></i></button>
              </div>
            }
          </div>
        }

        @if (!outcomes.length) {
          <div class="ws-empty-state">
            <i class="bi bi-geo-alt"></i>
            <p>No visit outcomes suggested. Add your own below.</p>
          </div>
        }

        <!-- Add new outcome -->
        <div class="d-flex align-items-center gap-2 mt-3">
          <input class="form-control form-control-sm" [(ngModel)]="newOutcomeName" placeholder="Add new outcome..." (keyup.enter)="addOutcome()" />
          <select class="form-select form-select-sm" style="width: 120px;" [(ngModel)]="newOutcomeNature">
            <option value="positive">Positive</option>
            <option value="neutral">Neutral</option>
            <option value="negative">Negative</option>
          </select>
          <button class="btn btn-sm btn-outline-primary" (click)="addOutcome()" [disabled]="!newOutcomeName.trim()">Add</button>
        </div>

        <!-- Feedback section -->
        <div class="ws-feedback-section">
          <div class="ws-feedback-label">Want different outcomes? Describe what you need:</div>
          <textarea [(ngModel)]="feedback" placeholder="e.g. We do home inspections — need outcomes like property approved, needs repairs, client not present, etc."></textarea>
          <div class="ws-feedback-actions">
            <button class="btn btn-sm btn-outline-primary" (click)="submitFeedback()" [disabled]="!feedback.trim()">
              <i class="bi bi-stars me-1"></i> Regenerate with AI
            </button>
          </div>
        </div>

        <div class="ws-save-row">
          <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
            @if (isSaving) {
              <span class="spinner-border spinner-border-sm me-1"></span>
            }
            Save & Continue
          </button>
        </div>
      }
    }
  </div>
</div>
